import { action, makeAutoObservable, observable } from 'mobx';
import { VCS_JOIN_POLICY } from 'consts';
import type { CallJoinPolicy } from 'features/AccessRequests/api/accessRequestsApi';

export interface CallPolicyDraft {
    joinPolicy: CallJoinPolicy;
    moderatorsApprovalOnly: boolean;
}

class CallPolicyStore {
    @observable public joinPolicy: CallJoinPolicy = VCS_JOIN_POLICY.ALL;
    @observable public moderatorsApprovalOnly = false;

    public constructor() {
        makeAutoObservable(this);
    }

    @action
    public set = (next: CallPolicyDraft): void => {
        this.joinPolicy = next.joinPolicy;
        this.moderatorsApprovalOnly = next.moderatorsApprovalOnly;
    };

    @action
    public update = (patch: Partial<CallPolicyDraft>): void => {
        if (patch.joinPolicy !== undefined) this.joinPolicy = patch.joinPolicy;
        if (patch.moderatorsApprovalOnly !== undefined) this.moderatorsApprovalOnly = patch.moderatorsApprovalOnly;
    };

    @action
    public reset = (): void => {
        this.joinPolicy = VCS_JOIN_POLICY.ALL;
        this.moderatorsApprovalOnly = false;
    };
}

export const callPolicyStore = new CallPolicyStore();
